/**
 * Beacon Service
 *
 * Handles facility-location (beacon) associations.
 * Single entry for /api/web-api/facility_locations endpoints.
 */

import { apiClient } from './apiClient';

/**
 * Associate beacon to location (facility).
 */
export const associateBeaconToLocation = async (facility) => {
  const response = await apiClient.post('/api/web-api/facility_locations/', facility);
  return response.data;
};

/**
 * Get beacon associations.
 */
export const getBeaconAssociations = async (facilityId) => {
  const response = await apiClient.get('/api/web-api/facility_locations/');
  return response.data;
};

/**
 * Update beacon association.
 */
export const updateBeaconAssociation = async (id, beaconAssociation) => {
  const response = await apiClient.patch(
    `/api/web-api/facility_locations/${id}/`,
    beaconAssociation,
  );
  return response.data;
};

/**
 * Delete beacon association.
 */
export const deleteBeaconAssociation = async (id) => {
  const response = await apiClient.delete(`/api/web-api/facility_locations/${id}/`);
  return response;
};
